(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("3e5er", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2596bcd4774f4870$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $gBmLA = parcelRequire("gBmLA");
var $2596bcd4774f4870$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Modal(param) {
        var el = param.el, isLargeQuery = param.isLargeQuery;
        (0, $J7ygF._)(this, Modal);
        this.el = el;
        this.isLargeQuery = isLargeQuery;
        this.closers = Array.from(this.el.querySelectorAll('.closer'));
        // has timer
        this.timer = parseInt(this.el.dataset.timer);
        this.cookieKey = 'june-popup';
        this.init();
    }
    (0, $hvJJn._)(Modal, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.closers.forEach(function(closer) {
                    closer.addEventListener('click', function(e) {
                        e.preventDefault();
                        _this.el.classList.remove('active');
                        document.body.style.overflow = 'initial';
                    });
                });
                if (this.timer && this.timer > 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($gBmLA))).get(this.cookieKey)) setTimeout(function() {
                    _this.el.classList.add('active');
                    document.body.style.overflow = 'hidden';
                    (0, (/*@__PURE__*/$parcel$interopDefault($gBmLA))).set(_this.cookieKey, 'true', {
                        expires: 1
                    });
                }, this.timer);
            }
        }
    ]);
    return Modal;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


})();
//# sourceMappingURL=Modal.e86d73d1.js.map
